
import { Component, Prop, Vue, Watch } from "nuxt-property-decorator";
import { ButtonText } from "~/operations/messages";

@Component({})
export default class UnorderedListAtom extends Vue {
  @Prop({ default: "excerpt" }) variant: string;
  @Prop({ default: "default" }) count: string;
  @Prop({ default: ButtonText.unfold }) buttonText: string;
  @Prop({ default: "black" }) buttonVariant: string;
  @Prop({ default: "default" }) buttonSize: string;

  ButtonText = ButtonText;

  internalVariant = "excerpt";
  excerptContentVisibility = false;

  @Watch("variant", { immediate: true })
  watchVariantForOutsideChanges(newVariant: string) {
    this.internalVariant = newVariant;
    this.excerptContentVisibility = newVariant === "default";
  }

  showHiddenContent() {
    this.excerptContentVisibility = !this.excerptContentVisibility;
    this.internalVariant = this.excerptContentVisibility
      ? "default"
      : "excerpt";
  }
}
